import React from 'react';
import styled from 'styled-components';

const LoaderS = styled.div`
  text-align: center;
`;

const Loading = (visible = true) => visible ? (<LoaderS>Loading...</LoaderS>) : null;

export { Loading };